
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive-tools",
      function () {
        return require("private-next-pages/archive-tools.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive-tools"])
      });
    }
  